import styled from "styled-components";
import { theme } from "../theme";

export const StyledEditField = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: ${(props) => props.mb || 0};

	&:nth-of-type(1) {
		margin-top: 0;
	}

	span {
		font-family: ${theme.font.secondary};
		font-weight: 500;
		flex-wrap: wrap;
		display: flex;
		align-items: center;
	}

	i {
		margin-right: 0.2rem;
		display: inline-flex;
		justify-content: center;
		align-items: center;
	}

	textarea {
		width: 80%;
		min-height: 15.5rem;
		font-size: 25px;
		font-weight: 900;
		padding: 1.5rem;
	}

	label {
		button {
			margin-left: 1rem;
		}
	}

	.wrapper {
		display: flex;
		align-items: flex-start;

		button {
			margin: 0 0 0 1.5rem;
			background: transparent;
			border: none;
			outline: none;
			cursor: pointer;
		}
	}
`;
